/* eslint-disable prettier/prettier */
import React, {
  Fragment,
  useState,
  useCallback,
  useEffect,
  useRef,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ChassiSearchItemsContainer from './ChassiSearch/ChassiSearchItemsContainer';
import { translate } from '../Services/translation';
import {
  loadSpareParts,
  clearchassisearch,
} from './../Actions/ChassiSearch.action';

const SparePartsContainer = ({ articleId }) => {
  const [viewStatus, setViewStatus] = useState(false);

  const dispatch = useDispatch();
  const hash = '#chassi-spareparts';
  const sparePartModel = useSelector((state) => state.chassisearch);
  let alreadyPushed = useRef(false);

  const {
    chassiSearchList,
    errors,
    pageInitialized,
    isloading,
    isDataerror,
  } = sparePartModel;

  const hashChange = useCallback(() => {
      if (!alreadyPushed.current && window.location.hash === hash) {
        alreadyPushed.current = true;
        dispatch(loadSpareParts(articleId));
      }
    },
    [articleId, dispatch]
  );

  useEffect(() => {
    hashChange(articleId);
    window.addEventListener('hashchange', hashChange, false);
    return () => {
      window.removeEventListener('hashchange', hashChange, false);
    };
  }, [hashChange, articleId]);

  const search = useCallback(() => {
      alreadyPushed.current = true;
      history.pushState(null, '', hash);
      dispatch(loadSpareParts(articleId));
    },
    [dispatch, articleId]
  );

  const onClickViewstatus = (value) => {
    setViewStatus(value);
  };

  const clear = () => {
    dispatch(clearchassisearch());
  };

  const sparePartList = chassiSearchList;

  return (
    <div className="row product-detail__row ">
      <div className="columns small-12 show-spare-parts">
        {!sparePartList.CategoryName ? (
          <button id="sparepartsbutton-show" className='toggle-btn-show' onClick={() => search()}>
            {translate('spareparts.show')}
          </button>
        ) : (
          <button id="sparepartsbutton-hide" className='toggle-btn-hide' onClick={() => clear()}>
            {translate('spareparts.hide')}
          </button>
        )}
      </div>

      {errors &&
        errors.length > 0 &&
        errors.map((error, index) => {
          return (
            <div className="chassi-search--error" key={'error' + index}>
              <svg>
                <use href="/ui/images/sprites/brenderup.svg#error"></use>
              </svg>
              {translate(error)}
            </div>
          );
        })}

      {isloading ? (
        <div className="loading--wrapper loading-spares">
          <div className="loading-circle"></div>
        </div>
      ) : (
        sparePartList.CategoryName && (
          <>
            <Fragment>
              <div className="columns small-12 text--right">
                <div className="chassi-search--switch-view">
                  <a
                    className={
                      viewStatus === false
                        ? 'switch grid active'
                        : 'switch grid '
                    }
                    onClick={() => onClickViewstatus(false)}
                  >
                    <svg>
                      <use href="/ui/images/sprites/brenderup.svg#grid-view"></use>
                    </svg>
                  </a>
                  <a
                    className={
                      viewStatus === true
                        ? 'switch list active'
                        : 'switch list '
                    }
                    onClick={() => onClickViewstatus(true)}
                  >
                    <svg>
                      <use href="/ui/images/sprites/brenderup.svg#list-view"></use>
                    </svg>
                  </a>
                </div>
              </div>
            </Fragment>
            <div className="columns small-12 show-spare-parts__product-views">
              <ChassiSearchItemsContainer
                category={sparePartList}
                id={0}
                isListView={viewStatus}
              />
            </div>
          </>
        )
      )}
    </div>
  );
};

export default SparePartsContainer;
